import { useTranslation } from 'react-i18next';

const useNavConfig = () => {
  const { t, i18n } = useTranslation(['page']);

  return [
    {
      title: t('제품소개'),
      path: '/guide',
      // icon: icon('ic_analytics'),
    },
    {
      title: t('이용안내'),
      path: '/license',
      // icon: icon('ic_user'),
    },

    {
      title: t('문의하기'),
      path: '/community',
      // icon: icon('ic_blog'),
    },
    {
      title: t('다운로드'),
      path: '/download',
      // icon: icon('ic_disabled'),
    },
  ];
};

const useNavLogin = () => {
  const { t, i18n } = useTranslation(['page']);

  return [
    {
      title: t('로그인'),
      path: '/login',
      // icon: icon('ic_lock'),
    },
  ];
};

export { useNavConfig, useNavLogin };
